import React, { createContext, useContext, useEffect, useState } from "react";
import { translations } from "@/i18n/translations";

const LangContext = createContext(null);

export const LangProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => localStorage.getItem("kaos_lang") || "it");

  const setLang = (l) => {
    setLangState(l);
    localStorage.setItem("kaos_lang", l);
  };

  const t = (key) => translations[lang]?.[key] ?? key;
  const tl = (obj) => (obj && typeof obj === "object" ? obj[lang] ?? obj.it : obj);

  return (
    <LangContext.Provider value={{ lang, setLang, t, tl }}>
      {children}
    </LangContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error("useLang must be used within LangProvider");
  return ctx;
};
